import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Editor from 'draft-js-plugins-editor';

class EditorComponent extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			editorState: this.props.editorState,
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState(state => ({ editorState: nextProps.editorState }));
	}

	updateEditorState = editorState => {
	  this.props.updateEditorState(editorState);
	}

	onChange = editorState => {
	  this.updateEditorState(editorState);
	}

	render() {
	  const { t } = this.props;

	  return (
	    <Editor
	      editorState={this.state.editorState}
	      onChange={this.onChange}
	      placeholder={t('controls/text/editor/Placeholder')}
	    />
	  )
	}
}

EditorComponent.propTypes = {
	editorState: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	changesHandler: PropTypes.func,
	updateEditorState: PropTypes.func,
	t: PropTypes.func,
}

export default translate('translations')(EditorComponent)
